import React, { type FunctionComponent } from 'react'
import { Breadcrumb, Breadcrumbs } from '@retailer-platform/shared-components'
import { useDashMessages } from 'intl/intl.hooks'
import { useScopedPathname } from 'utils/routing/url.hooks'

interface Props {
  pageType:
    | 'create'
    | 'update'
    | 'details'
    | 'list'
    | 'bannerTypeSelector'
    | 'visibilityConditionsList'
    | 'visibilityConditionCreate'
  placementName?: string
}

export const BannerBreadcrumbs: FunctionComponent<Props> = ({ pageType, placementName }) => {
  const messages = useDashMessages({
    home: 'bannersDomain.list.title',
    bannerTypeSelector: 'bannersDomain.create.typeSelect.title',
    create: 'bannersDomain.create.title',
    update: 'bannersDomain.edit.title',
    visibilityConditionsList: 'bannersDomain.visibility-conditions.list.title',
    visibilityConditionCreate: 'bannersDomain.visibility-conditions.create.title',
  })

  const appAdminBannersDetailsPath = useScopedPathname('app-admin-banners-details', {
    placementName,
  })

  const appAdminBannersVisibilityConditionsPath = useScopedPathname(
    'app-admin-banners-visibility-conditions',
    { placementName }
  )

  const appAdminBannersVisibilityConditionsCreate = useScopedPathname(
    'app-admin-banners-visibility-conditions-create',
    {
      placementName,
    }
  )

  return (
    <Breadcrumbs>
      <Breadcrumb path={useScopedPathname('app-admin-banners-list')}>{messages.home}</Breadcrumb>
      {placementName && <Breadcrumb path={appAdminBannersDetailsPath}>{placementName}</Breadcrumb>}
      {pageType != 'visibilityConditionsList' &&
        pageType != 'visibilityConditionCreate' &&
        messages[pageType] && <Breadcrumb>{messages[pageType]}</Breadcrumb>}
      {(pageType == 'visibilityConditionsList' || pageType == 'visibilityConditionCreate') && (
        <Breadcrumb path={appAdminBannersVisibilityConditionsPath}>
          {messages['visibilityConditionsList']}
        </Breadcrumb>
      )}
      {pageType == 'visibilityConditionCreate' && (
        <Breadcrumb path={appAdminBannersVisibilityConditionsCreate}>
          {messages['visibilityConditionCreate']}
        </Breadcrumb>
      )}
    </Breadcrumbs>
  )
}
